import {fetchWrapper} from "../../helpers/fetch.wrapper";

const baseUrl = process.env.REACT_APP_BASE_URL;

export const locationService = {getStates,getCities};

async function getStates() {

    return fetchWrapper.get(`${baseUrl}/locations/states`)
        .then(response => {
            return response;
        });
}

async function getCities(stateId) {

    return fetchWrapper.get(`${baseUrl}/locations/states/${stateId}/cities`)
        .then(response => {
            return response;
        });
}
